import { Link, useLocation } from 'react-router-dom';
import { Card, PageHeader } from '../components/ui.js';

/**
 * An address inside the signed-in shell that names no page.
 *
 * A page rather than a redirect to Home, so a mistyped or stale link says so
 * instead of quietly landing somewhere else.
 */
export function NotFoundPage() {
  const { pathname } = useLocation();

  return (
    <div className="space-y-4">
      <PageHeader title="Page not found" />
      <Card className="p-5">
        <p className="text-sm text-body">
          There is no page at <code className="rounded bg-sunken px-1">{pathname}</code>.
        </p>
        <p className="mt-3 text-sm">
          <Link to="/" className="text-brand-700 hover:underline">
            Go to Home
          </Link>
        </p>
      </Card>
    </div>
  );
}
